import React from 'react'
import R from 'ramda'
import PropTypes from 'prop-types'
import {
  Form,
  Button
} from 'semantic-ui-react'

import BaseNumberField from '_forms/baseNumber'

const propStr = prop => R.compose(
  R.defaultTo(''),
  R.prop(prop)
)

const getName = propStr('name')
const getEmail = propStr('email')
const getMaxVersion = R.prop('max_version')
const getSn = propStr('serial_number')

const SerialForm = ({
  serial,
  dirty,
  onSubmit,
  onChange,
  onCancel
}) => (
  <Form size='tiny' onSubmit={onSubmit}>
    <Form.Group>
      <Form.Input width={5} label='Name' name='name' placeholder='Name of user' value={getName(serial)} onChange={onChange} />
      <Form.Input width={5} label='Email' name='email' placeholder='Email (required)' value={getEmail(serial)} onChange={onChange} type='email'/>
    </Form.Group>
    <Form.Group>
      <BaseNumberField
        width={5}
        min={1}
        max={6}
        name='max_version'
        labelTxt='Max Version'
        popupTxt='Which max version(required)'
        placeholder='Which max version(required)'
        value={getMaxVersion(serial)}
        onChange={onChange}
      />
      <Form.Input width={5} label='Serial Number' name='serial_number' placeholder='Leave blank for server to auto-generate' value={getSn(serial)} onChange={onChange} />
    </Form.Group>
    <Button.Group>
      <Button disabled={!dirty} onClick={onCancel}>Cancel</Button>
      <Button.Or />
      <Button positive={dirty} disabled={!dirty} type="submit">Save</Button>
    </Button.Group>
  </Form>
)

SerialForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  serial: PropTypes.object.isRequired,
  dirty: PropTypes.bool.isRequired
}

export default SerialForm



// WEBPACK FOOTER //
// ./webAdmin/forms/serialForm.js